import './App.css';
import Router from './Router'
import  SocialMediaMenu from './components/SocialMediaMenu'

function App() {
  return (
    <>
      <Router />
      <SocialMediaMenu />
    </>
  );
}

export default App;
